import { SidebarNav } from './SidebarNav';
import { SidebarProjects } from './SidebarProjects';
import { OrganizationSwitcher } from '../../OrganizationSwitcher';
import { SidebarSecondaryNav } from './SidebarSecondaryNav';

export function HomePanel() {
  return (
    <div className="flex h-full min-h-0 flex-col">
      <SidebarNav />
      <div className="mx-3 border-t border-border shrink-0" />
      <OrganizationSwitcher />
      <SidebarSecondaryNav />
      <SidebarProjects />
    </div>
  );
}
